export default __webpack_public_path__ + "static/media/cal.493592b7.png";